const en = {
  listHeaderTitle: 'Certifications',
  listHeaderSubtitle: 'Create certifications to test contributors',
  createButtonLabel: 'Create certification',
  filtersButtonLabel: 'Filters',
  notifications: {
    requestAccessSuccess: 'Request for accessing the certification has been sent!',
    requestAccessError: 'Request for accessing the certification failed',
  },
  createModal: {
    title: 'Add a certification',
    subtitle: 'Create a certification',
    namePlaceholder: 'Example: English',
  },
  table: {
    accessLevel: 'Access level',
    name: 'Name',
    participantsNumber: 'Number of participants',
    timeAverage: 'Average time',
    scoreAverage: 'Average score',
    state: 'Status',
    successRate: 'Success rate',
  },
};

export default en;
export type Translations = typeof en;
